
import { callEndpoint } from '../baseApi'

export const GetAccountStatus = async (idToken) => {
    return await callEndpoint(`${process.env.REACT_APP_API}/accounts_summary/`, 'GET', idToken)
  }

export const GetAccountListByType = async (type, idToken) => {
    return await callEndpoint(`${process.env.REACT_APP_API}/accounts/${type}`, 'GET', idToken)
}